import React, { useState, forwardRef } from "react";
import { Dialog, DialogContent, IconButton, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function InvoicingModule({ open, onClose }) {
  const [loading, setLoading] = useState(true);

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          backgroundColor: "background.default",
          color: "text.primary",
        },
      }}
    >
      <IconButton
        edge="start"
        color="inherit"
        onClick={onClose}
        aria-label="close"
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          zIndex: 10,
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 0 }}>
        {loading && (
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "absolute",
              zIndex: 5,
              backgroundColor: "white",
            }}
          >
            <p>Loading invoice module…</p>
          </div>
        )}

        <iframe
          src="https://dalvado-facturacion.vercel.app"
          onLoad={() => setLoading(false)}
          style={{
            width: "100%",
            height: "100vh",
            border: "none",
            display: loading ? "none" : "block",
          }}
          title="Invoice Module"
        />
      </DialogContent>
    </Dialog>
  );
}
